import React from "react";

export type PaziaButtonType =
  | "primary"
  | "secondary"
  | "tertiary"
  | "danger"
  | "danger2"
  | "success"
  | "success2"
  | "yellow"
  | "yellow2";
export interface PaziaButtonProps {
  title?: string;
  type?: PaziaButtonType;
  disabled?: boolean;
  className?: string;
  innerClassName?: string;
  processing?: boolean;
  btnType?: "submit" | "button";
  buttonRef?: React.RefObject<HTMLButtonElement>;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
}

export const btnClasses: { [key in PaziaButtonType | "disabled"]: string } = {
  primary:
    "btn bg-primary-500 hover:bg-primary-600 text-white dark:bg-primary-600 dark:hover:bg-primary-700 dark:text-white",
  secondary:
    "btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-primary-500 dark:hover:text-primary-200",
  tertiary:
    "btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-slate-600 dark:text-slate-300",
  danger: "btn bg-rose-500 hover:bg-rose-600 text-white",
  danger2:
    "btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-rose-500",
  success: "btn bg-emerald-500 hover:bg-emerald-600 text-white",
  success2:
    "btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-emerald-500",
  disabled: "btn bg-gray-200 text-gray-400 dark:bg-slate-700 dark:text-slate-500 cursor-not-allowed",
  yellow: "btn bg-yellow-500 hover:bg-yellow-600 text-white",
  yellow2:
    "btn bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-yellow-500",
};

export const PaziaButton = ({
  title,
  type = "primary",
  onClick,
  processing,
  btnType = "submit",
  className,
  disabled,
  innerClassName = "",
  buttonRef,
  children,
}: PaziaButtonProps): JSX.Element => {
  const btnDisabled = disabled || processing;
  return (
    <button
      type={btnType}
      ref={buttonRef}
      className={`h-[2.375rem] ${btnClasses[btnDisabled ? "disabled" : type]} ${
        className ?? ""
      }`}
      onClick={onClick}
      disabled={btnDisabled}
    >
      {processing && <LoadingSpinner />}
      <span className={`${innerClassName} ${processing ? "ml-2" : ""}`}>
        {children ? children : title}
      </span>
    </button>
  );
};

const LoadingSpinner = () => {
  return (
    <svg
      className="animate-spin w-4 h-4 fill-current shrink-0"
      viewBox="0 0 16 16"
    >
      <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
    </svg>
  );
};
